import React, {useEffect, useState, useContext} from "react";
import ColorPicker from './ColorPicker';
import '../assets/css/dragableList.css';
import {postDataWithFetch} from './Utils';
import ApplicationContext from './ApplicationContext';

const DragableList = ({entryParser, list}) => {
	const [sourceElement, setSourceElement] = useState(null);
	const [sortedList, setSortedList] = useState([]);
	const data = useContext(ApplicationContext);

	useEffect(() => {
		if (list) {
			// console.log("DEBUG", list);
			setSortedList(list.map(e => [e[0], e[1], e[0]]))
		}
	}, [list]);

	const [clickedSave, setClickedSave] = useState(false);

	useEffect(() => {
		if (clickedSave) {
			(async() => {
				const url = `${data.BASE_URL}index.php/search_lookup/update_search_lookup_list`;
				const parms = {NEW_SEARCH_LIST: JSON.stringify(sortedList)};
				// console.log('DEBUG:  DragableList - ', url);
				// console.log('DEBUG:  DragableList - ', parms);
				const json = await postDataWithFetch(url, parms);
				setStatusText(`Saved ${json} records.`);
				// console.log('DEBUG:  output of update_search_lookup_list - ', typeof json, json);
				setClickedSave(false);
			})();	
		}
	}, [data.BASE_URL, clickedSave, sortedList]);

	const saveNewList = () => {
		setClickedSave(true);
	};

	// add a new entry at the end of the list.
	const newLine = () => {
		// console.log('DEBUG', sortedList);
		let tempList = [...sortedList];
		tempList.push(['', {foregroundColor: 'black', backgroundColor: 'white', enabled: '1', new: '1' }, '']);
		// console.log('DEBUG', tempList);
		setSortedList(tempList);
	};

	// change opacity for the dragged item. 
	// remember the source item for the drop later
	const handleDragStart = event => {
		// console.log('DEBUG', "entering handleDragStart here")
		event.target.style.opacity = 0.5;
		setSourceElement(event.target);
		event.dataTransfer.effectAllowed = 'move';
	};

	// do not trigger default event of item while passing (e.g. a link)
	const handleDragOver = event => {
		event.preventDefault();
		event.dataTransfer.dropEffect = 'move';
	};

	// add class .over while hovering other items
	const handleDragEnter = event => {
		event.target.classList.add('over');
	};

	// remove class .over when not hovering over an item anymore
	const handleDragLeave = event => {
		event.target.classList.remove('over');
	};

	const handleDrop = event => {
		// prevent redirect in some browsers
		event.stopPropagation();

		// only do something if the dropped on item is 
		// different to the dragged item

		if (sourceElement !== event.target) {
			// console.log("DEBUG:  ", `moving ${sourceElement.id} to ${event.target.id}`);
			/* remove dragged item from list */
			const list = sortedList.filter((item, i) => i.toString() !== sourceElement.id);
			// console.log("DEBUG:  sourceElement = ", sourceElement.id)
			// console.log("DEBUG", list)
			// list.forEach(e => console.log("DEBUG", e))

			/* this is the removed item */
			const removed = sortedList.filter((item, i) => i.toString() === sourceElement.id);
			// console.log("DEBUG", removed)
			// removed.forEach(e => console.log("DEBUG", e))

			/* insert removed item after this number. */
			let insertAt = Number(event.target.id);
			// console.log("DEBUG:  event.target.id = ", event.target.id);

			// console.log('list with item removed', list);
			// console.log('removed:  line', removed);
			// console.log('insertAt index', insertAt);

			let tempList = [];

			/*
				if dropped at last item, don't increase target id by +1.
				max-index is arr.length
			*/
			if (insertAt >= list.length) {
				// console.log('DEBUG', 'shouldn\'t get here ');
				tempList = list.slice(0).concat(removed);
				setSortedList(tempList);
			}
			else if (insertAt < list.length) {
				/* original list without removed item until the index it was removed at */
				tempList = list.slice(0, insertAt).concat(removed);

				// console.log('DEBUG', 'tempList', tempList);
				// console.log('DEBUG', 'insert the rest: ', list.slice(insertAt));

				/* add the remaining items to the list */
				const newList = tempList.concat(list.slice(insertAt));
				// console.log('DEBUG', 'newList', newList);

				/* set state to display on page */
				setSortedList(newList);
			}
			event.target.classList.remove('over');
		}
		// else {
		// 	console.log("DEBUG:", 'nothing happened');
		// }

		event.target.classList.remove('over');
	};

	const handleDragEnd = event => {
		event.target.style.opacity = 1;
		// console.log('-------------------------------------------------------------');
	};

	// log changes in current input field
	const handleChange = event => {
		event.preventDefault();
		// console.log('event.target.value', event.target.value);

		// create new list where everything stays the same except that the current
		// item replaces the existing value at this index
		const list = sortedList.map((item, i) => {
			if (i !== Number(event.target.id)) {
				return [item[0], item[1], item[2]];
			}
			else {
				return [event.target.value, item[1], item[2]];
			};
		});
		setSortedList(list);
	};

	// filter list where only items with id unequal to current id's are allowed
	const handleDelete = (event, index) => {
		let tempList = [...sortedList];

		// console.log('DEBUG:  old value = ', tempList[event.target.id][1].enabled)

		tempList[event.target.id][1].enabled = 
			tempList[event.target.id][1].enabled === "1" ? "0" : "1";

		// console.log('DEBUG:  new value = ', tempList[event.target.id][1].enabled)

		setSortedList(tempList);
	};

	const handleNew = (event, index) => {
		let tempList = [...sortedList];

		// console.log('DEBUG:  old value = ', tempList[event.target.id][1].new)

		tempList[event.target.id][1].new = 
			tempList[event.target.id][1].new === "1" ? "0" : "1";

		// console.log('DEBUG:  new value = ', tempList[event.target.id][1].new)

		setSortedList(tempList);
	};

	const [statusText, setStatusText] = useState("");

	return (
		<>
			{/* {(() => {
				console.log("DEBUG", "Rendering sortedList.map() function here...");
			})()} */}
			{sortedList.map((item, i, arr) => {
				let res = entryParser(item);
				// console.log("DEBUG", "Rendering res.enabled", i, res.enabled);
				// console.log("DEBUG", "Rendering res.foregroundColor", res.foregroundColor);
				if (typeof res?.title === 'string' && res?.backgroundColor && res?.foregroundColor) {
					return (
						<div key={i} id={i} draggable="true" className="input-container"
							onDragStart={handleDragStart} 
							onDragOver={handleDragOver} 
							onDragEnter={handleDragEnter} 
							onDragLeave={handleDragLeave} 
							onDrop={handleDrop} 
							onDragEnd={handleDragEnd} >
							<input id={i} className="color-input" draggable="false"
								style={{
									backgroundColor: res.backgroundColor,
									color: res.foregroundColor
								}}
								type="text" 
								placeholder="Enter New Category" 
								onChange={handleChange}
								value={res.title} 
							/>
							<div id={i} className="color-picker" draggable="false">
								<ColorPicker color={res.foregroundColor} handleColorChange={(newColor) => {
									arr[i][1].foregroundColor = newColor;
									setSortedList([...arr]);
								}} />
							</div>
							<div id={i} className="color-picker" draggable="false">
								<ColorPicker color={res.backgroundColor} handleColorChange={(newColor) => {
									arr[i][1].backgroundColor = newColor;
									setSortedList([...arr]);
								}} />
							</div>
							<div className="button-container">
								<input id={i} className="delete-button" type="checkbox" 
								checked={res.enabled === "1" ? true : false} onChange={handleDelete} />
								<label htmlFor={i} >ENABLED</label>
							</div>
							<div className="button-container">
								<input id={i} className="delete-button" type="checkbox" 
								checked={res.new === "1" ? true : false} onChange={handleNew} />
								<label htmlFor={i}>NEW</label>
							</div>
						</div>
					)
				}
				// Probably never gets here but in case anything is not valid at this point...
				else {
					// console.log("DEBUG", "error condition", res)
					return (<div key={i}></div>);
				}
			})}
			<div className="btn-container">
				<button className="button" onClick={() => newLine()}>ADD</button>
			</div>
			<div className="btn-container">
				<button className="button" onClick={saveNewList}>SAVE</button>
			</div>
			<div className="drabable-status-text" style={{display: statusText?.length ? 'block' : 'none'}}>
				<p className="paragraph-status-text">{statusText}</p>
			</div>
		</>
	);
};

export default DragableList;
